/**
 * copayFigures.js - PROD-976: the copay a doctor ROLE shows comes from that role's own figure.
 *
 * The API (rcm_service._parse_271_response) keeps three copay fields on an eligibility result:
 * copayPcpCents, copaySpecialistCents and the generic copayCents. When the 271 has no generic line
 * the API fills copayCents with a roll-up of a ROLE figure (the specialist's first). So with a role
 * figure present, copayCents is only a copy of one role's number: reading it as the other role's
 * figure shows a specialist copay as the patient's PCP / office-visit copay.
 *
 *   own figure present            -> it (0 is a value: "no copay")
 *   NEITHER role figure present   -> the generic copayCents (a flat-copay plan: it can only be the
 *                                    plan's own generic line)
 *   the other role's figure only  -> null (the generic would be that other role's number)
 *
 * Pure. Gate: scripts/check-copay-role-figure.mjs.
 */
export function roleCopayCents(eligibility, role) {
  const e = eligibility || {}
  const own = role === 'pcp' ? e.copayPcpCents : e.copaySpecialistCents
  const other = role === 'pcp' ? e.copaySpecialistCents : e.copayPcpCents
  if (own != null) return own
  if (other == null) return e.copayCents ?? null
  return null
}
